export default function generateStaticReference(style, selector) {
  if (typeof style === 'string') {
    return style;
  }

  if (selector) {
    return selector + JSON.stringify(style);
  }

  return '';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateStaticReference.js
// module id = 701
// module chunks = 0